import CreditScoringSummary from '.';
import { compose, lifecycle } from 'recompose';
import { withProcessedProps } from '../../Misc/forms/withFieldProcessedProps';
import withGetTriggerValidityHandler from '../../Misc/forms/withGetTriggerValidityHandler';
import withDependencyCheckHandler from '../../Misc/forms/withDependencyCheckHandler';

const EnhancedCreditScoringSummary = compose(
    withProcessedProps,
    withGetTriggerValidityHandler,
    withDependencyCheckHandler,
    lifecycle({
        componentDidMount() {
            const { dependencyCheck } = this.props;
            dependencyCheck(true);
        },
    }),
);

export default EnhancedCreditScoringSummary(CreditScoringSummary);
